import { defer } from 'react-router-dom'
import { logger } from '$utils'
import useAppStore, { isAppStateReady } from '$appStore'
import useCompanySettingsStore from '../store'

export default async function loader() {
  logger.debug(
    '[loader] About to await AppState being ready in Company Preferences loader'
  )
  await isAppStateReady()
  logger.debug(
    '[loader] AppState should now be ready in Company Preferences loader'
  )

  // Get the active company, needed for the loader requests
  const { activeCompany } = useAppStore.getState()

  /**
   * We need to check if the both defaultPayTypes and customPayTypes have already been populated (as this request populates both states) and if not then do the API call again
   * (This could happen when we refresh the Preferences.Page as the Preferences loader
   * does not run and also when switching tabs)
   */
  const defaultPayTypes =
    useCompanySettingsStore.getState().defaultPayrollPayTypes
  const customPayTypes =
    useCompanySettingsStore.getState().customPayrollPayTypes
  const getPayrollPayTypes =
    defaultPayTypes.length > 0 || customPayTypes.length > 0
      ? defaultPayTypes
      : useCompanySettingsStore.getState().getPayrollPayTypes()

  /**
   * We need to check if the localeSalesTax has already been populated and if not then do the API call again
   * (This could happen when we refresh the Preferences.Page as the Preferences loader
   * does not run and also when switching tabs)
   */
  const localeSalesTax = useCompanySettingsStore.getState().localeSalesTax
  const getLocaleSalesTax =
    localeSalesTax.length > 0
      ? localeSalesTax
      : useCompanySettingsStore.getState().getLocaleSalesTax(activeCompany)

  /**
   * We need to check if the companySalesTax has already been populated and if not then do the API call again
   * (This could happen when we refresh the Preferences.Page as the Preferences loader
   * does not run and also when switching tabs)
   */
  const companySalesTax = useCompanySettingsStore.getState().companySalesTax
  const getCompanySalesTax =
    companySalesTax.length > 0
      ? companySalesTax
      : useCompanySettingsStore.getState().getCompanySalesTax()

  /**
   * We need to check if the posItems has already been populated and if not then do the API call again
   * (This could happen when we refresh the Preferences.Page as the Preferences loader
   * does not run and also when switching tabs)
   */
  const posItems = useCompanySettingsStore.getState().posItems
  const getPosItems =
    posItems.length > 0
      ? posItems
      : useCompanySettingsStore.getState().getPosItems()

  return defer({
    data: Promise.all([
      getPayrollPayTypes,
      getLocaleSalesTax,
      getCompanySalesTax,
      getPosItems,
    ])
      .then(() => true)
      .catch((error) => {
        logger.error('Company Preferences Promise.all error', error)
        return false
      }),
  })
}
